import { Props_SnippetIconsText } from "./IconsText.props";
import SnippetLink from '../Shared/Link/Link';
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const IconsText = (props: Props_SnippetIconsText) => {
    const {
        heading,
        repeatable_iconsTextContentOptions: items,
        snippet
    } = props;

    const headingClass = "snippet-icons-text__heading " + (heading.visibility?.value ? "" : "snippet-icons-text__heading--hidden");

    const columnCount = snippet?.columns?.value || 3;
    const sectionClass = `snippet-icons-text snippet-icons-text--cols-${columnCount}`;

    return (
        <section className={sectionClass} data-testid="icons-text-section">
            <div className="snippet-icons-text__container">
                {heading?.content?.value && <h2 className={headingClass}>
                    {heading.content.value}
                </h2>}

                <ul className="snippet-icons-text__card-container">
                    {items.map(({ image, imageAltText, cardHeading, content, linkHref, linkStyle, linkTarget, linkText }, index) => (
                        <li key={"card" + index} className="snippet-icons-text__card" data-testid="icons-text-card">
                            {image?.value && <figure className="snippet-icons-text__icon-container">
                                <img
                                    loading="lazy"
                                    src={image.value}
                                    alt={imageAltText?.value || ""}
                                    className="snippet-icons-text__icon"
                                    height="150"
                                    width="150"
                                ></img>
                            </figure>}
                            <div className="snippet-icons-text__info-container">
                                {cardHeading?.value && <h3 className="snippet-icons-text__card-heading">
                                    {cardHeading.value}
                                </h3>}
                                {content?.value && <div className="snippet-icons-text__text">
                                    {CompileMarkdown(content.value)}
                                </div>}

                                <SnippetLink
                                    url={linkHref?.value}
                                    className="snippet-icons-text__link"
                                    linkStyles={linkStyle?.value}
                                    openInNewTab={linkTarget?.value}
                                >
                                    {linkText?.value}
                                </SnippetLink>
                            </div>
                        </li>
                    )
                    )}
                </ul>
            </div>
        </section>
    );
};

export default IconsText;
